<template>
  <v-container>
    <div class="row">
      <div class="col-md-10 col-sm-12 col-xs-12 top">
        <v-flex lg10 md10 sm11 xs>
          <div class="form-group">
            <label class="left" for="sel1">Elige un centro de costo para cargar archivos</label>
            <select class="form-control" id="5" @change="cargaArchivos()" v-model="cc">
              <option selected disabled>-Selecciona una opción-</option>
              <option
                v-for="(centro,index) in centros"
                :key="index"
                :value="centro"
              >{{centro.ccNombre}}</option>
            </select>
          </div>
        </v-flex>
        <v-flex lg10 md10 sm11 xs v-if="cc !=''">
          <v-card class="top">
            <h1>{{cc.ccNombre}} {{cc.ccValor}}</h1>
            <v-layout row>
              <v-flex md9 sm9 xs9>
                <v-text-field
                  label="Lineamientos estratégicos"
                  @click="pickFile('0')"
                  v-model="FileName[0]"
                  prepend-icon="attach_file"
                  :disabled="this.filesDge['dge'][0]['saved'] == 'si'"
                ></v-text-field>
                <input
                  type="file"
                  id="file0"
                  ref="myFiles0"
                  style="display: none"
                  class="custom-file-input"
                  @change="previewFiles('0')"
                  multiple
                />
              </v-flex>

              <v-flex md2 sm1 xs1>
                <v-btn
                  v-if="this.filesDge['dge'][0]['saved'] == 'si'"
                  fab
                  outline
                  small
                  color="#394049"
                  v-on:click="downloadFile('0')"
                >
                  <v-icon dark>save_alt</v-icon>
                </v-btn>
                <v-btn
                  v-if="this.filesDge['dge'][0]['saved'] == 'no'"
                  fab
                  outline
                  small
                  color="#EC6A12"
                  v-on:click="submitFile('0')"
                  :disabled="disabled[0]"
                >
                  <v-icon color="#394049" dark>publish</v-icon>
                </v-btn>

                <v-btn
                  v-if="this.filesDge['dge'][0]['saved'] == 'si'"
                  fab
                  outline
                  small
                  color="#EC6A12"
                  v-on:click="deleteFile('0')"
                >
                  <v-icon color="#394049" dark>delete</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card>

          <v-card>
            <v-layout row>
              <v-flex md9 sm9 xs9>
                <v-text-field
                  label="Diagnóstico 'Matriz de densidad'"
                  @click="pickFile('1')"
                  v-model="FileName[1]"
                  prepend-icon="attach_file"
                  :disabled="this.filesDge['dge'][1]['saved'] == 'si'"
                ></v-text-field>
                <input
                  type="file"
                  id="file1"
                  ref="myFiles1"
                  style="display: none"
                  class="custom-file-input"
                  @change="previewFiles('1')"
                  multiple
                />
              </v-flex>

              <v-flex md2 xs1>
                <v-btn
                  v-if="this.filesDge['dge'][1]['saved'] == 'si'"
                  fab
                  outline
                  small
                  color="#394049"
                  v-on:click="downloadFile('1')"
                >
                  <v-icon dark>save_alt</v-icon>
                </v-btn>
                <v-btn
                  v-if="this.filesDge['dge'][1]['saved'] == 'no'"
                  fab
                  outline
                  small
                  color="#EC6A12"
                  v-on:click="submitFile('1')"
                  :disabled="disabled[1]"
                >
                  <v-icon color="#394049" dark>publish</v-icon>
                </v-btn>

                <v-btn
                  v-if="this.filesDge['dge'][1]['saved'] == 'si'"
                  fab
                  outline
                  small
                  color="#EC6A12"
                  v-on:click="deleteFile('1')"
                >
                  <v-icon color="#394049" dark>delete</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card>

          <v-card>
            <v-layout row>
              <v-flex md9 xs9>
                <v-text-field
                  label="Planes Operativos 2018-2019"
                  @click="pickFile('2')"
                  v-model="FileName[2]"
                  prepend-icon="attach_file"
                  :disabled="this.filesDge['dge'][2]['saved'] == 'si'"
                ></v-text-field>
                <input
                  type="file"
                  id="file2"
                  ref="myFiles2"
                  style="display: none"
                  class="custom-file-input"
                  @change="previewFiles('2')"
                  multiple
                />
              </v-flex>

              <v-flex md2 xs1>
                <v-btn
                  v-if="this.filesDge['dge'][2]['saved'] == 'si'"
                  fab
                  outline
                  small
                  color="#394049"
                  v-on:click="downloadFile('2')"
                >
                  <v-icon dark>save_alt</v-icon>
                </v-btn>
                <v-btn
                  v-if="this.filesDge['dge'][2]['saved'] == 'no'"
                  fab
                  outline
                  small
                  color="#EC6A12"
                  v-on:click="submitFile('2')"
                  :disabled="disabled[2]"
                >
                  <v-icon color="#394049" dark>publish</v-icon>
                </v-btn>
                <v-btn
                  v-if="this.filesDge['dge'][2]['saved'] == 'si'"
                  fab
                  outline
                  small
                  color="#EC6A12"
                  v-on:click="deleteFile('2')"
                >
                  <v-icon color="#394049" dark>delete</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card>

          <v-card class="bot">
            <v-layout row>
              <v-flex md9 xs9>
                <v-text-field
                  label="Informe Jornada Estratégica"
                  @click="pickFile('3')"
                  v-model="FileName[3]"
                  prepend-icon="attach_file"
                  :disabled="this.filesDge['dge'][3]['saved'] == 'si'"
                ></v-text-field>
                <input
                  type="file"
                  id="file3"
                  ref="myFiles3"
                  style="display: none"
                  class="custom-file-input"
                  @change="previewFiles('3')"
                  multiple
                />
              </v-flex>

              <v-flex md2 xs1>
                <v-btn
                  v-if="this.filesDge['dge'][3]['saved'] == 'si'"
                  fab
                  outline
                  small
                  color="#394049"
                  v-on:click="downloadFile('3')"
                >
                  <v-icon dark>save_alt</v-icon>
                </v-btn>
                <v-btn
                  v-if="this.filesDge['dge'][3]['saved'] == 'no'"
                  fab
                  outline
                  small
                  color="#EC6A12"
                  v-on:click="submitFile('3')"
                  :disabled="disabled[3]"
                >
                  <v-icon color="#394049" dark>publish</v-icon>
                </v-btn>
                <v-btn
                  v-if="this.filesDge['dge'][3]['saved'] == 'si'"
                  fab
                  outline
                  small
                  color="#EC6A12"
                  v-on:click="deleteFile('3')"
                >
                  <v-icon color="#394049" dark>delete</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </div>
    </div>
  </v-container>
</template>


<script>
export default {
  /*
      Defines the data used by the component
    */
  data() {
    return {
      centros: "",
      cc: "",
      auth: {
        headers: { Authorization: "" + this.$session.get("jwt") }
      },
      path: "",
      disabled: [true, true, true, true, true],
      file: "",
      filesDge: "",
      filess: {
        0: "",
        1: "",
        2: "",
        3: "",
        4: ""
      },
      FileName: {
        0: "",
        1: "",
        2: "",
        3: "",
        4: ""
      }
    };
  },

  created() {
    axios
      .get(
        process.env.ROOT_API + "/centrocosto/getAllByAcademicoSimple",
        this.auth
      )
      .then(response => {
        this.centros = response.data;
        //console.log(this.centros);
      })
      .catch(error => {
        console.error(error);
      });
  },

  methods: {
    /*
        Submits the file to the server
      */
    submitFile(index) {
      /*
                Initialize the form data
            */

      let formData = new FormData();
      var name = this.filess[index].name;
      //console.log("indice: " + index);
      /*
                Add the form data we need to submit
            */
      formData.append("file", this.filess[index]);
      //console.log(formData);

      /*
          Make the request to the POST /single-file URL
        */

      axios
        .post(
          process.env.ROOT_API +
            "/uploadFileDcaEtc/createFile?cc=" +
            this.cc.ccValor,
          formData,
          this.auth
        )
        .then(response => {
          //console.log("SUCCESS!!");
          //console.log(response.data);
          this.path = response.data;
          this.filesDge.dge[index]["saved"] = "si";
          this.filesDge.dge[index]["path"] = response.data[0];
          this.filesDge.dge[index]["name"] = response.data[1];
          alert("Archivo: " + name + " fue cargado exitosamente.");
        })
        .catch(error => {
          //console.log("FAILURE!!");
          alert("Error al cargar el archivo" + name + " ," + error);
        })
        .then(response => {
          axios
            .post(
              process.env.ROOT_API +
                "/uploadFileDcaEtc/updateFileValue?ccValor=" +
                this.cc.ccValor +
                "&tipoData=dge",
              this.filesDge.dge,
              this.auth
            )
            .then(response => {
              //console.log(response.data);
              //console.log("funcionando");
            })
            .catch(error => {
              console.error(error);
            });
        });
    },

    /*
        Handles a change on the file upload
      */
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
      //console.log(this.file);
    },

    deleteFile(index) {
      //console.log(index);
      //console.log(this.cc.ccValor);
      //console.log(this.auth);
      axios
        .post(
          process.env.ROOT_API +
            "/uploadFileDcaEtc/eraseFile?idCc=" +
            this.cc.ccValor +
            "&index=" +
            index,
          this.auth
        )
        .then(response => {
          //console.log(response);
          alert("Archivo eliminado exitosamente");
          this.cargaArchivos();
        })
        .catch(error => {
          console.error(error);
        });
    },

    cargaArchivos() {
      (this.filess = {
        0: "",
        1: "",
        2: "",
        3: "",
        4: ""
      }),
        (this.FileName = {
          0: "",
          1: "",
          2: "",
          3: "",
          4: ""
        });

      (this.disabled = [true, true, true, true, true]),
        axios
          .get(
            process.env.ROOT_API +
              "/uploadFileDcaEtc/getByCcValor?ccValor=" +
              this.cc.ccValor,
            this.auth
          )
          .then(response => {
            this.filesDge = response.data;
            //console.log(this.filesDge);
            //console.log(this.filesDge["dge"][1]);
          })
          .catch(error => {
            console.error(error);
          });
    },

    previewFiles(index) {
      //console.log(index);
      this.filess[index] = this.$refs["myFiles" + index].files[0];
      //console.log(this.filess);
      this.FileName[index] = this.$refs["myFiles" + index].files[0].name;
    },
    pickFile(index) {
      //console.log("entrando a pick file");
      this.$refs["myFiles" + index].click();
      this.disabled[index] = false;
    },

    // TODO
    downloadFile(index) {
      //console.log("Descargando archivo ....");
      var pathFile = this.convertPath(this.filesDge.dge[index]["path"]);
      var nameFile = this.filesDge.dge[index]["name"];
      //console.log(nameFile);
      axios
        .get(
          process.env.ROOT_API +
            "/uploadFileDcaEtc/downloadFile?dir=" +
            pathFile,
          {
            responseType: "arraybuffer",
            headers: { Authorization: "" + this.$session.get("jwt") }
          }
        )
        .then(response => {
          //console.log("archivo descargado ....");
          //console.log(response);
          this.forceFileDownload(response, nameFile);
        })
        .catch(error => {
          console.error(error);
        });
    },

    convertPath(string) {
      var info = string.split("\\").join("/");
      return info;
    },

    forceFileDownload(response, nameFile) {
      //console.log("Aqui va el header");
      //console.log(response.headers);
      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: response.headers["content-type"] })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", nameFile); //or any other extension
      document.body.appendChild(link);
      link.click();
    }
  }
};
</script>


<style scoped>
.v-card {
  margin-bottom: 1%;
  padding-right: 3%;
  padding-left: 3%;
  padding-top: 0.5%;
}

.top {
  margin-top: 50px;
}

.bot {
  margin-bottom: 50px;
}

.primary--text {
  color: #ec6a12 !important;
  caret-color: #ec6a12 !important;
}

.v-text-field .v-label--active {
  color: #ec6a12 !important;
}

.v-btn--floating.v-btn--small {
  height: 35px !important;
  width: 35px !important;
  margin-top: 15px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/primeraEtapa/DgeCc.vue